export const debounce = (
  fn: (...args: unknown[]) => unknown,
  ms: number
): (() => void) => {
  let timeout: NodeJS.Timeout;

  return function (...args: unknown[]) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const fnCall = () => fn.apply(this, args);

    if (timeout !== undefined) {
      clearTimeout(timeout);
      return;
    }

    timeout = setTimeout(fnCall, ms);
  };
};
